<template>
  <popup-modal ref="popup">
    <div class="modal-scroll">
      <h3>Migrer terminal</h3>
      <p class="mt-3">Migrer ordrer og Z-rapporter fra terminal <strong>{{ fromTerminalId }}</strong> for valgt periode</p>

      <div class="mb-3">
        <label class="form-label">Mål terminal-ID</label>
        <input type="text" class="form-control" v-model="toTerminalId" placeholder="Skriv inn mål terminal-ID">
      </div>

      <SelectDate ref="fromDate" label="Fra og med dato" :selectedDate="fromDateString"/>
      <SelectDate ref="toDate" label="Til og med dato" :selectedDate="toDateString"/>

      <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
      <div v-if="successMessage" class="alert alert-info">{{ successMessage }}</div>

      <div v-if="fromCounters && toCounters" class="mt-3 mb-3">
        <h5>Tellere etter migrering</h5>
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Teller</th>
              <th>Fra ({{ fromCounters.terminalId }})</th>
              <th>Til ({{ toCounters.terminalId }})</th>
              <th>Match</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in counterRows" :key="row.key">
              <td>{{ row.label }}</td>
              <td>{{ row.fromValue }}</td>
              <td>{{ row.toValue }}</td>
              <td :class="row.match ? 'text-success' : 'text-danger'">{{ row.match ? '✓' : '✗' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="btn-panel">
        <button class="bo_btn btn-width" @click="cancel">{{ successMessage ? 'Lukk' : 'Avbryt' }}</button>
        <button v-if="!successMessage" class="bo_btn btn-width ms-3" @click="confirm" :disabled="migrating || !toTerminalId">
          {{ migrating ? 'Migrerer...' : 'Bekreft' }}
        </button>
      </div>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/other/PopupModal.vue'
import SelectDate from '@/components/other/SelectDate.vue'
import TerminalService from '@/services/terminal/TerminalService'
import moment from 'moment'

export default {
  name: 'MigrateTerminalModal',
  components: { PopupModal, SelectDate },
  data() {
    return {
      fromTerminalId: '',
      locationId: '',
      toTerminalId: '',
      fromDateString: moment().format('YYYY-MM-DD'),
      toDateString: moment().format('YYYY-MM-DD'),
      errorMessage: '',
      successMessage: '',
      migrating: false,
      fromCounters: null,
      toCounters: null,
    }
  },
  computed: {
    counterRows() {
      if (!this.fromCounters || !this.toCounters) return []
      const fields = [
        { key: 'grandTotalSales', label: 'Grand Total Sales' },
        { key: 'grandTotalRefund', label: 'Grand Total Refund' },
        { key: 'saleReceiptsCount', label: 'Sale Receipts Count' },
        { key: 'copyReceiptsCount', label: 'Copy Receipts Count' },
        { key: 'copyReceiptsTotalAmount', label: 'Copy Receipts Total Amount' },
        { key: 'refundReceiptsCount', label: 'Refund Receipts Count' },
        { key: 'refundReceiptsTotalAmount', label: 'Refund Receipts Total Amount' },
        { key: 'cashBoxOpeningsCount', label: 'Cash Box Openings Count' },
        { key: 'discountsCount', label: 'Discounts Count' },
        { key: 'discountsTotalAmount', label: 'Discounts Total Amount' },
        { key: 'uncompletedSalesCount', label: 'Uncompleted Sales Count' },
        { key: 'uncompletedSalesTotalAmount', label: 'Uncompleted Sales Total Amount' },
      ]
      const format = (val) => {
        if (val == null) return 0
        return Number.isInteger(val) ? val : parseFloat(val.toFixed(2))
      }
      return fields.map(f => ({
        key: f.key,
        label: f.label,
        fromValue: format(this.fromCounters[f.key]),
        toValue: format(this.toCounters[f.key]),
        match: this.fromCounters[f.key] === this.toCounters[f.key],
      }))
    }
  },
  methods: {
    open(fromTerminalId, locationId) {
      this.fromTerminalId = fromTerminalId
      this.locationId = locationId
      this.toTerminalId = ''
      this.fromDateString = moment().format('YYYY-MM-DD')
      this.toDateString = moment().format('YYYY-MM-DD')
      this.errorMessage = ''
      this.successMessage = ''
      this.migrating = false
      this.fromCounters = null
      this.toCounters = null
      this.$refs.popup.open()
    },
    cancel() {
      this.$refs.popup.close()
    },
    confirm() {
      this.errorMessage = ''
      this.migrating = true
      const fromDate = this.$refs.fromDate.getSelectedDate()
      const toDate = this.$refs.toDate.getSelectedDate()
      TerminalService.migrateTerminal(this.fromTerminalId, this.toTerminalId, this.locationId, fromDate, toDate).then(
        (response) => {
          this.migrating = false
          this.successMessage = 'Husk å dobbelsjekke tellere/counters for terminalen som skal brukes som er den gjeldende på den fysiske enheten. Etter migreringen skal tellere på begge terminalene ha samme riktige verdier. Det gjenstår kun manuell endring av terminalId til den gjeldende terminal til å bli id til den gamle/target terminalen og slett den gamle/target terminalen.'
          if (response.data && response.data.fromTerminal && response.data.toTerminal) {
            this.fromCounters = response.data.fromTerminal
            this.toCounters = response.data.toTerminal
          }
          this.$emit('migrated')
        },
        (error) => {
          this.migrating = false
          this.errorMessage = error.response?.data?.message || 'Migrering feilet. Prøv igjen.'
        }
      )
    }
  }
}
</script>

<style scoped>
.btn-panel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: var(--bo-muted-2) solid 1px;
  padding-top: 15px;
}

.btn-width {
  width: 80px;
  text-align: center;
}

.modal-scroll {
  max-height: 80vh;
  overflow-y: auto;
  margin-right: -1rem;
  padding-right: 1rem;
}
</style>
